import { AppSettings } from "../Constants/AppSettings"
import { loadData, UserDataProvider } from "../Core/UserDataProvider"
import { duringParsingError } from "../Helpers/FetchData"
import { controllers } from "./Controllers"
import { navigator } from "./Navigator"


class UserController {

    // resendEmail = async () => {
    //     const { userToken } = controllers().auth
    //     const response = await loadData(UserDataProvider.resendEmail, {userToken})
    //     return response
    // }
    
    // verifyEmail = async (token:any) => {
    //     const response = await loadData(UserDataProvider.verifyEmail, {token})
    //     return response
    // }
    
    // exportData = async () => {
    //     const { userToken } = controllers().auth
    //     const response = await loadData(UserDataProvider.exportData, {userToken})
    //     return response
    // }
    // deactivateAccount = async () => {
    //     const { userToken } = controllers().auth
    //     const response = await loadData(UserDataProvider.deactivateAccount, {userToken})
    //     controllers().auth.signOut()
    //     navigator().navigate('/')
    //     return response
    // }
    // deleteAccount = async () => {
    //     const { userToken } = controllers().auth
    //     const response = await loadData(UserDataProvider.deleteAccount, {userToken})
    //     return response
    // }
    
    // getNotificationSettings = async () => {
    //     const { userToken } = controllers().auth
    //     const response = await loadData(UserDataProvider.getNotificationSettings, {userToken})
    //     return response
    // }
    // updateProfile = async (body: any) => {
    //     const { userToken } = controllers().auth
    //     const response = await loadData(UserDataProvider.updateProfile, {...body, userToken})
    //     return response
    // }
    // updatePassword = async (body: any) => {
    //     const { userToken } = controllers().auth
    //     const response = await loadData(UserDataProvider.updatePassword, {...body, userToken})
    //     return response
    // }
    // updateNotificationSettings = async (body: any) => {
    //     const { userToken } = controllers().auth
    //     const response = await loadData(UserDataProvider.updateNotificationSettings, {...body, userToken})
    //     return response
    // }
    // updateProfilePicture = async (body: any) => {
    //     const { userToken } = controllers().auth
    //     body.append('userToken', userToken)
    //     const response = await this.uploadPictureRequest(body)
    //     return response
    // }

    // uploadPictureRequest = async (body:any):Promise<any> => {
    //         try {
    //             const response:any = await fetch(`${AppSettings.endpoint}/settings/update-profile-picture/`, {
    //                 method: 'POST',
    //                 body
    //             });
    //             if (response.ok) {
    //                 const result:any = await response.json();
    //                 // console.log('Upload successful:', result);
    //                 return result;
    //             } else {
    //                 // console.error('Upload failed:', response.status);
    //                 return duringParsingError;
    //             }
    //         } catch (error) {
    //             // console.error('Upload error:', error);
    //             return duringParsingError;
    //         }
    //     }
}

export {UserController}